export default "__VITE_ASSET__CgV9tNsv__"